export const bigCommerceEndpointTags = ['Cart', 'Customer', 'Order', 'PriceList', 'Product', 'ProductImage', 'Shipping'] as const;

export type BigCommerceEndpointTagTypes = typeof bigCommerceEndpointTags[number];
